import React from "react"
import PropTypes from "prop-types"

import { Link } from "gatsby"
import Button from "../ui/button/Button"
import Container from "../../hoc/container/Container"

import img1 from "../../assets/images/footer/silhouette-1.jpg"
import img2 from "../../assets/images/footer/silhouette-2.jpg"

import style from "./Footer.module.css"

const Footer = ({ showForm }) => {
  return (
    <footer className={style.footer}>
      <Container containerClass={style.content}>
        <h3>Fufil is the world’s first social growth platform</h3>
        <p>Together it’s our mission to raise fulfillment around the world!</p>
        <a
          href="https://fufilapp.netlify.app/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Button
            pressed={showForm}
            label="JOIN THE MOVEMENT"
            contained={true}
            small={true}
          />
        </a>

        <div style={{ marginTop: 40 }}>
          <p style={{ fontSize: "small", fontWeight: 500 }}>
            Questions? <a href="mailto: fufilapp@gmail.com">Email us here</a>
          </p>
        </div>
      </Container>
      <div className={style.images}>
        <img src={img1} />
        <img src={img2} />
      </div>

      <div className={style.copyright}>
        © 2020 Loopspeed Ltd | <Link to="/legal"> Privacy Policy</Link>
      </div>
    </footer>
  )
}

Footer.propTypes = {}
Footer.defaultProps = {}

export default Footer
